var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-list-table',{attrs:{"title":"Коннекторы","data-service":_vm.dataService,"headers":_vm.headers,"create-route-name":"connector-create","edit-route-name":"connector-edit","allow-delete":"","show-status-column":false},scopedSlots:_vm._u([{key:"item.source",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.source.name)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }